import React from 'react';
import lexemes from 'components/lexemes';
import LocaleContext from 'lib/locale-context';
import CookieNotification from 'components/cookie-notification/cookie-notification';

const PageCookie = () => {
    const lang = React.useContext(LocaleContext);
    const cookiePolicyLink = `https://badoo.com/${lang}/cookie-policy`;
    const cookieNotificationText = lexemes.cookies.lxCookieBannerText({ cookiePolicyLink });

    return <CookieNotification text={cookieNotificationText} hasCta={true} />;
};

export default PageCookie;
